import React from 'react';
import { observer } from 'mobx-react';
import { UserSubscriptionStore } from '@seedlang/stores';
import UserSearch from 'components/user_search';
import autobind from 'autobind-decorator';

@observer
class UserSubscriptionCreate extends React.Component {

  @autobind onSelectUser(user) {
    UserSubscriptionStore.create(
      {
        data: {
          subscriptionId: this.props.subscriptionId,
          userId: user.id,
        },
      },
      this.props.afterUpdate,
    );
    this.refs.transactionId.value = '';
  }

  render() {
    return (
      <UserSearch
        onSubmit={this.onSelectUser}
        placeholder='Add User by Email'
        displayField='name'
      />
    );
  }
}

export default UserSubscriptionCreate;
